module.exports = __webpack_public_path__ + "img/PublicationTitle.3d27651e.png";